export enum ESearchType {
  List = 'list',
  Map = 'map',
}

export interface ISearchStringAPI {
  setFilterJsonQuery: (jsonQuery: object) => Promise<void>;
  clickSearchSuggestion: (type: ESearchType) => Promise<IClickSearchSuggestionResult>;
}

export interface ISearchStringResult {
  success: boolean;
  error?: string;
}

export interface IClickSearchSuggestionResult {
  success: boolean;
  dispatchedEvent: string;
  eventDetail: { type: ESearchType };
}
